import Index from './Index.vue';

export default {
  path: 'meus-dados',
  name: 'meus-dados',
  component: Index,
};
